module.exports = __webpack_public_path__ + "static/media/about.837089ad.jpg";